export var SET_FIELD = 'SET_FIELD';
export var SET_CEF_APPLICATION_FIELD = 'SET_CEF_APPLICATION_FIELD';
export var REMOVE_FIELD = 'REMOVE_FIELD';
export var SET_WORKFLOW_DATA = 'SET_WORKFLOW_DATA';
export var UPDATE_VALID_KEY = 'UPDATE_VALID_KEY';
export var INITIALIZE = 'INITIALIZE';